<script setup lang="ts">
import BaseLayout from "./base.vue";
</script>

<template>
  <base-layout class="bg-ngray-6 overflow-auto px-6 pt-4 flex flex-col gap-4">
    <template #header>
      <minimal-content-header />
    </template>
    <template #mainContent>
      <main class="relative flex flex-col bg-white rounded-lg flex-1">
        <section class="relative flex flex-col bg-white rounded-lg flex-1">
          <slot />
        </section>
      </main>
    </template>
  </base-layout>
</template>
